export default __webpack_public_path__ + "static/media/aiautomation.7ae014e5.svg";